import {isFloat} from './numberUtils';
import {getSiteCurrency} from './selectors';

// used to return amount with extra floating point
export const formatAmountString = (amount, currency = '') => {
	if (!currency) currency = getSiteCurrency();
	return `${isFloat(amount) ? parseFloat(amount).toFixed(2) : amount} ${currency}`;
};
